import { Participant } from '@seen/core/models/patients/participant'
import type { ValidatedToolResponse } from '@seen/core/models/validatedToolResponse'
import indefiniteArticle from 'indefinite'
import type { ReactNode } from 'react'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

interface ValidatedToolResponseItemProps {
  validatedToolResponse: ValidatedToolResponse
}

export function ValidatedToolResponseItem({
  validatedToolResponse,
}: ValidatedToolResponseItemProps): ReactNode {
  const { data: participant } = useRead(
    Participant,
    validatedToolResponse.subjectPatient
  )
  const name = validatedToolResponse.name ?? 'validated tool'

  return (
    <TimelineTextEntry
      actor={validatedToolResponse.author ?? 'Unknown'}
      time={validatedToolResponse.authored}
      action={
        <>
          administered{' '}
          {indefiniteArticle(name, {
            articleOnly: true,
          })}{' '}
          <TextLink
            to={`${participant?.relativeUrl}/validated-tools/responses/${validatedToolResponse.id}`}
          >
            {name}
          </TextLink>
        </>
      }
      reference={validatedToolResponse.reference}
      originTask={validatedToolResponse.queuedEditsOriginTask}
    />
  )
}
